import { render, staticRenderFns } from "./kanban.vue?vue&type=template&id=7400d832&"
import script from "./kanban.vue?vue&type=script&lang=js&"
export * from "./kanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7400d832')) {
      api.createRecord('7400d832', component.options)
    } else {
      api.reload('7400d832', component.options)
    }
    module.hot.accept("./kanban.vue?vue&type=template&id=7400d832&", function () {
      api.rerender('7400d832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/kanban.vue"
export default component.exports